import React from 'react'
import { SetPageScrollYPositionProvider } from 'providers/SetPageScrollYPositionProvider'

export const withPageScrollPosition = (PageComponent: React.FC, pageRoute: string) => () => (
  <SetPageScrollYPositionProvider pageRoute={pageRoute}>
    <PageComponent />
  </SetPageScrollYPositionProvider>
)
